import User from "./User";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";

export default class CallHistoriesRequest extends DBObject {
  private static readonly _OFFSET: number = 0;
  private static readonly _PAGESIZE: number = 1;
  private static readonly _USER: number = 2;
  public id: number = 0;
  public otherMaster: DBObject;
  private _user: User = null;
  private _pageSize: number = 0;
  private _offset: number = 0;
  public constructor(
    d3eParams?: Partial<{ offset: number; pageSize: number; user: User }>
  ) {
    super();

    this.setOffset(d3eParams?.offset ?? 0);

    this.setPageSize(d3eParams?.pageSize ?? 0);

    this.setUser(d3eParams?.user ?? null);
  }
  public get d3eType(): string {
    return "CallHistoriesRequest";
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get isTransientModel(): boolean {
    return;
  }
  public get user(): User {
    return this._user;
  }
  public setUser(val: User): void {
    let isValChanged: boolean = this._user !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(CallHistoriesRequest._USER, this._user);

    this.updateObservable("user", this._user, val);

    this._user = val;

    this.fire("user", this);
  }
  public get pageSize(): number {
    return this._pageSize;
  }
  public setPageSize(val: number): void {
    let isValChanged: boolean = this._pageSize !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(CallHistoriesRequest._PAGESIZE, this._pageSize);

    this._pageSize = val;

    this.fire("pageSize", this);
  }
  public get offset(): number {
    return this._offset;
  }
  public setOffset(val: number): void {
    let isValChanged: boolean = this._offset !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(CallHistoriesRequest._OFFSET, this._offset);

    this._offset = val;

    this.fire("offset", this);
  }
  public get(field: number): any {
    switch (field) {
      case CallHistoriesRequest._USER: {
        return this._user;
      }

      case CallHistoriesRequest._PAGESIZE: {
        return this._pageSize;
      }

      case CallHistoriesRequest._OFFSET: {
        return this._offset;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): CallHistoriesRequest {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: CallHistoriesRequest = dbObj as CallHistoriesRequest;

    obj.id = this.id;

    obj.setUser(this._user);

    obj.setPageSize(this._pageSize);

    obj.setOffset(this._offset);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case CallHistoriesRequest._USER: {
        this.setUser(value as User);
        break;
      }

      case CallHistoriesRequest._PAGESIZE: {
        this.setPageSize(value as number);
        break;
      }

      case CallHistoriesRequest._OFFSET: {
        this.setOffset(value as number);
        break;
      }
    }
  }
}
